var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"s-vam"},[_c('span',{staticClass:"u-dimmed u-font-sm"},[_vm._v(_vm._s(_vm.$t('playback_rate'))+": ")]),_vm._v(" "),_c('button',{staticClass:"button button_xs rate-switcher",attrs:{"title":_vm.$t('change_playback_rate')},on:{"click":_vm.updateRate}},[_vm._v("\n    "+_vm._s(_vm.rate)+"x\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-532a82a9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PlaybackRate.vue
// module id = null
// module chunks = 